/* (c) Copyright Frontify Ltd., all rights reserved. */

export const zIndexLayers = {
    floatingToolbar: 50,
    toolbarTooltip: 51,
    textStyleDropdown: 52,
    combobox: 100,
    emojiPopover: 100,
    floatingModal: 1000,
};
